import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dataForm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-title" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "underlineForm"
}
const _hoisted_7 = {
  key: 1,
  class: "form-calc"
}
const _hoisted_8 = {
  key: 1,
  class: "form-calc"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "dialog-footer mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_OrderFeeDesc = _resolveComponent("OrderFeeDesc")!
  const _component_FromField = _resolveComponent("FromField")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
        _createElementVNode("span", { class: "label green" }, "业"),
        _createElementVNode("span", { class: "left" }, "业务基本信息")
      ], -1)),
      _createVNode(_component_el_descriptions, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "业务编号：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.no), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "公司名称：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.customerCompanyName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "业务品牌：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.brand), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "业务名称：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "型号：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.model), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "序列号：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.serial), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "数量：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.amount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "单位：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.unit), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "业务类型：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.type), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "维修状态：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.repairType), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "外包公司：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.outsourceCompanyName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "外包公司联系人：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.businessDetail.outsourceCompanyContactName), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.businessDetail.orderNo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-title mb-10" }, [
            _createElementVNode("span", { class: "label blue" }, "订"),
            _createElementVNode("span", { class: "left" }, "订单信息")
          ], -1)),
          _createVNode(_component_OrderFeeDesc, { detail: _ctx.businessDetail }, {
            before: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "订单编号：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.businessDetail.orderNo), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["detail"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromFieldData, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_form, {
        class: "mb-20",
        ref_for: true,
        ref: el => _ctx.dataForm[index] = el,
        model: item,
        "label-position": "top",
        "label-width": "100px",
        key: index,
        disabled: _ctx.formDisabled
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["label", item.labelClass])
            }, _toDisplayString(item.labelName), 3),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
            (item.type === 2 && !item.formList.length && _ctx.canAdd)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.handleAdd(item)),
                  class: "add-icon add-title cursor"
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "iconfont icon-tubiao-25" }, null, -1)
                ]))], 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          (item.type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formList, (fields, k) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                    (_ctx.handleVisible(fields, item.formList))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: _normalizeClass([fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]),
                          error: fields.rules[0].message,
                          rules: fields.rules,
                          prop: 'formList.' + k + '.value',
                          label: fields.fieldName
                        }, {
                          default: _withCtx(() => [
                            (fields.componentType !== 'el-calc')
                              ? (_openBlock(), _createBlock(_component_FromField, {
                                  key: 0,
                                  fields: fields,
                                  onFormChange: ($event: any) => (_ctx.handleChange(fields, item.formList)),
                                  id: _ctx.id
                                }, null, 8, ["fields", "onFormChange", "id"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.calcRate(fields, item.formList)), 1))
                          ]),
                          _: 2
                        }, 1032, ["class", "error", "rules", "prop", "label"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (item.type === 2)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.formList, (j, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: k,
                  class: "border-container"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(j.list, (fields, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (_ctx.handleVisible(fields, j.list))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: _normalizeClass([fields.componentType, { fullWidth: fields.config.width }]),
                            rules: fields.rules,
                            prop: 'formList.' + k + '.list.' + i + '.value',
                            label: fields.fieldName,
                            error: fields.rules[0].message
                          }, {
                            default: _withCtx(() => [
                              (fields.componentType !== 'el-calc')
                                ? (_openBlock(), _createBlock(_component_FromField, {
                                    key: 0,
                                    fields: fields,
                                    onFormChange: ($event: any) => (_ctx.handleChange(fields, j.list)),
                                    id: _ctx.id
                                  }, null, 8, ["fields", "onFormChange", "id"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.calcRate(fields, j.list)), 1))
                            ]),
                            _: 2
                          }, 1032, ["class", "rules", "prop", "label", "error"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (_ctx.canAdd)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleDelete(item.formList, k)),
                        class: "delete-icon"
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (k === item.formList.length - 1 && _ctx.canAdd)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.handleAdd(item)),
                        class: "add-icon cursor add-list"
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "iconfont icon-tubiao-25" }, null, -1)
                      ]))], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["model", "disabled"]))
    }), 128)),
    (_ctx.isShowCloseBtn || _ctx.isShowSubmitBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.isShowCloseBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _ctx.cancle,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('table.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isShowSubmitBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                loading: _ctx.submitLoading,
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('table.confirm')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}